import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { ValidationProvider } from 'vee-validate'
import '@/plugins/vee-validate'
import vuetify from './plugins/vuetify'
import { injectMarchOwnGtm } from '@/analytics/march-gtm'

Vue.config.productionTip = false

injectMarchOwnGtm(process.env.VUE_APP_MARCH_GTM_ID || '')

Vue.component('ValidationProvider', ValidationProvider)

const vm = new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')

export default vm
